import PropTypes from "prop-types";
import React from "react";

const ContestedMarkAsResolvedMessage = ({ recognitionRecipient }) => (
    <li>
        <div className="message-container is-poster">
            <p className="body">{i18n.t("rtm.text.still_need_help")}</p>
        </div>
        <div className="system-message">
            <p className="body">
                {i18n.t("rtm.text.reply_and_let_them_know_why", {
                    recognitionRecipientName: recognitionRecipient.name,
                })}
            </p>
        </div>
    </li>
);

ContestedMarkAsResolvedMessage.propTypes = {
    recognitionRecipient: PropTypes.object.isRequired,
};

export default ContestedMarkAsResolvedMessage;
